import React, { useContext, useEffect, useState } from 'react';
import { useStore } from 'common/store';
import { UseStoreValues } from 'common/types/store';
import { OptionType } from 'components/CustomSelect/types';
import FeaturedSpreadsheetContext from 'components/FeaturedSpreadsheet/context/FeaturedSpreadsheetContext';
import SelectValueViewer from 'components/SelectValueViewer';

const EntityValueViewer = (props: any) => {
  const [availableEntities, setAvailableEntities] = useState<OptionType[]>([]);
  const [{ companyInfo }] = useStore() as unknown as UseStoreValues;
  const { onCellsChanged } = useContext(FeaturedSpreadsheetContext) as any;

  useEffect(() => {
    if (!companyInfo) {
      return;
    }
    const tempEntities = [
      {
        id: String(companyInfo.id),
        value: String(companyInfo.id),
        label: companyInfo.name || '',
      },
      ...(companyInfo?.child_companies || []).map((child: any) => ({
        id: String(child.company_id),
        value: String(child.company_id),
        label: child.company_name || '',
      })),
    ];

    if (availableEntities.length === 0) {
      setAvailableEntities(tempEntities);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyInfo]);

  useEffect(() => {
    if (!props.cell.value && companyInfo) {
      onCellsChanged([{ cell: props.cell, value: companyInfo.id }]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.cell.value]);

  if (availableEntities.length === 0) {
    return null;
  }

  return <SelectValueViewer {...props} options={availableEntities} />;
};

export default EntityValueViewer;
